/**
 * Currency amounts travel as doubles, and `1.1 * 100` is not `110`. Comparing two such products
 * with `===` reads as diverging although the amounts match, so every comparison and every sum
 * has to go through whole cents.
 *
 * The detour via `toFixed` absorbs the error the multiplication introduces - `1.005` is stored
 * as `1.00499...`, and rounding that directly would drop the half cent instead of raising it.
 */
export const toCents = (amount: number): number => Math.round(Number((amount * 100).toFixed(4)));

export const roundToCents = (amount: number): number => toCents(amount) / 100;
